module.exports = __webpack_public_path__ + "ecbaf32b20de3ad4023c91093aa6ad0c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GL.svg
// module id = dT4q
// module chunks = 0